module.exports = __webpack_public_path__ + "img/leadership-1980-an-gang.5ba0d6db.jpg";